import React from 'react'
import PropTypes from 'prop-types'
import ContentContainer from 'components/ContentContainer'

const PartnersContentContainer = ({ children }) => (
  <ContentContainer top="calc(17vh - 40px)">
    {children}
  </ContentContainer>
)

PartnersContentContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}
export default PartnersContentContainer
